import React from "react";
import {Table} from "semantic-ui-react";
import {NumericFormat} from 'react-number-format';


export default function CostCentersTable(props) {
    const {costcenters} = props
    return (
        <div>
            <Table size='small'>
                <Table.Header>
                    <Table.Row key='header'>
                        <Table.HeaderCell>Kostenstelle</Table.HeaderCell>
                        <Table.HeaderCell>1</Table.HeaderCell>
                        <Table.HeaderCell>2</Table.HeaderCell>
                        <Table.HeaderCell>3</Table.HeaderCell>
                        <Table.HeaderCell>4</Table.HeaderCell>
                        <Table.HeaderCell>5</Table.HeaderCell>
                        <Table.HeaderCell>6</Table.HeaderCell>
                        <Table.HeaderCell>7</Table.HeaderCell>
                        <Table.HeaderCell>8</Table.HeaderCell>
                        <Table.HeaderCell>9</Table.HeaderCell>
                        <Table.HeaderCell>10</Table.HeaderCell>
                        <Table.HeaderCell>11</Table.HeaderCell>
                        <Table.HeaderCell>12</Table.HeaderCell>
                        <Table.HeaderCell>AVG</Table.HeaderCell>
                        <Table.HeaderCell>Gesamt</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {costcenters.length > 0 && costcenters.map((cost_center, index) => (
                            <Table.Row key={cost_center.cost_center}>
                                <Table.Cell key={cost_center.cost_center}>{cost_center.cost_center}</Table.Cell>
                                {cost_center.chartdata && cost_center.chartdata.map((month, index) => (
                                    <Table.Cell key={cost_center.cost_center + index}>
                                        <NumericFormat value={month.y}
                                                       displayType={'text'}
                                                       thousandSeparator={true}
                                                       prefix={'€'}
                                                       decimalScale={2}
                                                       fixedDecimalScale={true}
                                        />
                                    </Table.Cell>
                                ))}
                                <Table.Cell key={cost_center.cost_center + "avg" + index}>
                                    <NumericFormat value={cost_center.avg}
                                                   displayType={'text'}
                                                   thousandSeparator={true}
                                                   prefix={'€'}
                                                   decimalScale={2}
                                                   fixedDecimalScale={true}
                                    />
                                </Table.Cell>
                                <Table.Cell key={cost_center.cost_center + "bt" + index}>
                                    <NumericFormat value={cost_center.balance_total}
                                                   displayType={'text'}
                                                   thousandSeparator={true}
                                                   prefix={'€'}
                                                   decimalScale={2}
                                                   fixedDecimalScale={true}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        )
                    )
                    }
                </Table.Body>
            </Table>
            <p>Hinweis: Der AVG ist inkl. dem aktuellen Monat</p>
        </div>
    )
}